/*
* Report page
*/

import * as _ from 'lodash';
import * as React from 'react';
import ReactImageFallback from 'react-image-fallback';

import { Formatters } from '../../../common/formatters';
import * as BidLetterReportComponents from '../../bid-letter/report-components';
import ApiEndpoints from '../../../config/apiendpoints';

export const OverrideSealedBidProposal = false;

export const Render = ({ reportData, appText, ...rest }) => {
    const { currentOrder, branding, association, associationClient, offices, orderClient, pricingMatrix, serviceLevels, orderManagerUser, ...otherReportData } = reportData;

    const orderClientStateCode = Formatters.getStr(currentOrder, 'association.client.location.stateCode');

    const assocClientRegionId = Formatters.getInt(associationClient, 'regionId');
    const associationClientOffice = _.find(offices, (o) => {
        return (_.find(_.get(o, 'regions', []), { 'regionId': assocClientRegionId })) ? true : false;
    });

    const associationClientOfficeLocation = _.get(associationClientOffice, 'location', {});

    const orderAssocCompanyBrandKey = Formatters.getStr(currentOrder, 'company.brandKey');

    // Footer image
    let footerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-envelope-header-2022.png`;
    let footerNotFoundPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-envelope-header-2022.png`;

    const footerImageObj = {
        src: ApiEndpoints.getBidLetterUserSignaturePictureUrl(footerPath, false),
        fallbackSrc: ApiEndpoints.getBidLetterUserSignaturePictureUrl(footerNotFoundPath, false),
    };

    const returnAddress = (
        <div className="pdf-order-bid-envelope-return-address">
            {Formatters.getStr(associationClientOfficeLocation, 'address1')}<br />
            {Formatters.composeLocationCityStateZipCountry(associationClientOfficeLocation, false)}<br />
        </div>
    );

    const bidAddress = (
        <div className="pdf-order-bid-envelope-client-address">
            {(Formatters.getStr(association, 'name')) ? (
                <div>
                    {Formatters.getStr(association, 'name')}
                </div>
            ) : (<span />)}

            {(Formatters.getStr(currentOrder, 'orderClientContactLetter')) ? (
                <div>
                    {appText('address-care-of')} {Formatters.getStr(currentOrder, 'orderClientContactLetter')}
                </div>
            ) : (<span />)}

            {(Formatters.getStr(currentOrder, 'association.client.name')) ? (
                <div>
                    {Formatters.getStr(currentOrder, 'association.client.name')}
                </div>
            ) : (<span />)}

            {(Formatters.getStr(currentOrder, 'association.client.location.address1')) ? (
                <div>
                    {Formatters.getStr(currentOrder, 'association.client.location.address1')}
                </div>
            ) : (<span />)}

            {(Formatters.getStr(currentOrder, 'orderClientAddressCityStateZip')) ? (
                <div>
                    {Formatters.getStr(currentOrder, 'orderClientAddressCityStateZip')}
                </div>
            ) : (<span />)}
        </div>
    );

    return (
        <div>
            <BidLetterReportComponents.ReportEnvelopePage className="pdf-order-bid-envelope-page" reportData={reportData}>
                <div className="text-left pdf-order-bid-envelope-return-address-wrapper">
                    <ReactImageFallback
                        src={footerImageObj.src}
                        fallbackImage={footerImageObj.fallbackSrc}
                        className="pdf-order-bid-envelope-return-address-header-image"
                    />
                    {/* {returnAddress} */}
                </div>

                {(orderClientStateCode === 'NV' || OverrideSealedBidProposal) ? (
                    <div className="pdf-order-bid-envelope-client-sealed-bid-proposal-wrapper">
                        <div className="pdf-order-bid-envelope-client-sealed-bid-proposal pdf-order-bid-envelope-client-sealed-bid-proposal-left text-center">
                            {appText('sealed-bid-proposal')}
                        </div>
                        <div className="pdf-order-bid-envelope-client-sealed-bid-proposal pdf-order-bid-envelope-client-sealed-bid-proposal-right text-center">
                            {appText('sealed-bid-proposal')}
                        </div>
                    </div>
                ) : (<div />)}

                <div className="text-left pdf-order-bid-envelope-client-address-wrapper">
                    {bidAddress}
                </div>
            </BidLetterReportComponents.ReportEnvelopePage>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/order/bid-envelope/pages/report-page-envelope.tsx